<template>
  <LegacyPageContent v-if="hasProfile">
    <v-row
      no-gutters
      align="center"
      class="mb-6"
    >
      <v-col>
        <div class="headline">
          Opportunities
        </div>
      </v-col>

      <v-spacer />

      <!-- <v-col class="text-right">
        <v-btn
          rounded
          color="primary"
          dark
          small
          @click="createOpp"
        >
          Create New
        </v-btn>
      </v-col> -->
    </v-row>

    <v-row no-gutters>
      <v-tabs
        grow
        v-model="activeTab"
        class="mb-3"
        @change="handleTabsChange"
      >
        <v-tab
          href="#all"
          class="ml-0"
        >
          ALL
          <span v-if="adminAllOpps.length > 0">
            &nbsp;({{ adminAllTotal }})
          </span>
        </v-tab>

        <v-tab href="#supportRequested">
          Support requested
          <span v-if="supportRequestedTotal">
            &nbsp;({{ supportRequestedTotal }})
          </span>
        </v-tab>

        <v-tab href="#supportProvided">
          Support provided
          <span v-if="supportProvidedTotal">
            &nbsp;({{ supportProvidedTotal }})
          </span>
        </v-tab>
      </v-tabs>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <v-tabs-items
          v-model="activeTab"
          class="px-1"
        >
          <v-tab-item value="all">
            <SearchField
              label="Opportunities"
              :search="searchField.adminAllOpps"
              @clearSearch="clearSearch"
              @searching="handleSearch('adminAllOpps', $event)"
            />

            <CreateOpportunityBtn @createNewOpp="createOpp" />

            <listOpportunities
              v-if="adminAllOpps"
              :items="adminAllOpps"
              :display="{ role: true, location: true }"
              :is-fetching-more="pagination.adminAllOpps.isFetching"
              :total="adminAllTotal"
              :page="pagination.adminAllOpps.page"
              :is-searching="isSearching('adminAllOpps')"
              @viewOppDetails="handleShowViewOppDialog"
              @fetchMore="handleFetchMore('adminAllOpps', $event)"
            />
          </v-tab-item>

          <v-tab-item value="supportRequested">
            <SearchField
              label="Support requested"
              :search="searchField.supportRequested"
              @clearSearch="clearSearch"
              @searching="handleSearch('supportRequested', $event)"
            />
            <listOpportunities
              v-if="supportRequested"
              :items="supportRequested"
              :display="{ role: true, location: true, publisher: true }"
              :is-fetching-more="pagination.supportRequested.isFetching"
              :total="supportRequestedTotal"
              :page="pagination.supportRequested.page"
              :is-searching="isSearching('supportRequested')"
              @viewOppDetails="handleShowViewOppDialog"
              @fetchMore="handleFetchMore('supportRequested', $event)"
            />
          </v-tab-item>

          <v-tab-item value="supportProvided">
            <SearchField
              label="Support provided"
              :search="searchField.supportProvided"
              @clearSearch="clearSearch"
              @searching="handleSearch('supportProvided', $event)"
            />
            <listOpportunities
              v-if="supportProvided"
              :items="supportProvided"
              :display="{ publisher: true, location: true }"
              :is-fetching-more="pagination.supportProvided.isFetching"
              :total="supportProvidedTotal"
              :page="pagination.supportProvided.page"
              :is-searching="isSearching('supportProvided')"
              @viewOppDetails="handleShowViewOppDialog"
              @fetchMore="handleFetchMore('supportProvided', $event)"
              @showApplicants="showApplicantsDialog"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <ViewApplicantsModule
      ref="$viewApplicantsModule"
      :show-applicants-dialog.sync="applicantsDialog"
      :opportunity-selected="opportunitySelected"
    />

    <v-dialog
      v-model="createDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition-10"
    >
      <createOpportunity
        @hide="handleHideCreateDialog"
        @submitOpp="submitOpp"
        @editOpp="editOpp"
        :edit-opportunity="opportunitySelected"
      />
    </v-dialog>

    <v-dialog
      v-model="viewDialog"
      fullscreen
      transition="slide-x-reverse-transition"
    >
      <viewOpportunity
        :opportunity="opportunitySelected"
        @edit="editOpp"
        @hide="handleHideViewOppDialog"
        @unpublish="unpublishDialog = true"
        @showApplicants="showApplicantsDialog"
        @viewApp="viewApplicationDialog"
        @shareOpp="shareOppDialog = true"
      />
    </v-dialog>

    <v-dialog
      v-model="unpublishDialog"
      :retain-focus="false"
      transition="slide-y-transition"
    >
      <unpublishDialog
        @hide="unpublishDialog = false"
        @unpublish="unpublish"
        :opportunity="opportunitySelected"
      />
    </v-dialog>
    <v-dialog
      v-model="shareOppDialog"
      :retain-focus="false"
      transition="slide-y-transition"
      max-width="600"
    >
      <shareOpportunity
        @hide="shareOppDialog = false"
        :opportunity="opportunitySelected"
        :is-displayed="shareOppDialog"
      />
    </v-dialog>
  </LegacyPageContent>
</template>
<script lang="ts">
import { mapState, mapGetters } from 'vuex'
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'

import SearchField from '@/components/core/SearchField.vue'
import createOpportunity from '@/components/opportunities/createOpportunity.vue'
import viewOpportunity from '@/components/opportunities/viewOpportunity.vue'
import listOpportunities from '@/components/opportunities/listOpportunities.vue'
import unpublishDialog from '@/components/opportunities/unpublishOpportunity.vue'
import shareOpportunity from '@/components/opportunities/shareOpportunity.vue'
import CreateOpportunityBtn from '@/components/opportunities/CreateOpportunityBtn.vue'
import ViewApplicantsModule from '@/components/opportunities/applicants/ViewApplicantsModule.vue'
import ViewSearchMixin, { IViewSearchMixin } from '@/mixins/ViewSearch.mixin'
import OpportunitiesPageMixin, { IOpportunitesPageMixin } from '@/mixins/OpportunitiesPage.mixin'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'
import { MODAL_TRANSITION_TIME, PAGINATION_LIMIT } from '@/constants'
import { waitAsync } from '@/utils/common'
import { IOpportunity } from '@/types/models/opportunity.model'
import { IOppSearchField } from '@/types/filters'
import { IPagination } from '@/types/api'
import { AdminOppsListName } from '@/store/adminOpportunities'
import { Route } from 'vue-router'

const ViewMixins = Mixins(ViewSearchMixin, OpportunitiesPageMixin)

@Component({
  computed: {
    ...mapGetters([
      'isAdmin',
      'adminAllOpps',
      'supportProvided',
      'supportRequested',
      'adminAllTotal',
      'supportProvidedTotal',
      'supportRequestedTotal'
    ]),
  },
  components: {
    SearchField,
    createOpportunity,
    viewOpportunity,
    listOpportunities,
    unpublishDialog,
    shareOpportunity,
    ViewApplicantsModule,
    CreateOpportunityBtn,
    LegacyPageContent
  },
})
export default class AdminOpportunities extends ViewMixins implements IViewSearchMixin, IOpportunitesPageMixin {
  @Prop() hasProfile: boolean

  // data
  get routeName (): string {
    return 'adminOpportunities'
  }

  pagination: {
    [key: string]: any
  } = {
    adminAllOpps: {
      isFetching: false,
      page: 0
    },
    supportProvided: {
      isFetching: false,
      page: 0
    },
    supportRequested: {
      isFetching: false,
      page: 0
    }
  }

  searchField: {
    [key: string]: IOppSearchField
  } = {
    adminAllOpps: {
      headline: '',
      industry: '',
      location: ''
    },
    supportProvided: {
      headline: '',
      industry: '',
      location: ''
    },
    supportRequested: {
      headline: '',
      industry: '',
      location: ''
    }
  }

  // computed
  // mapGetters
  isAdmin: boolean
  adminAllOpps: IOpportunity[]
  supportProvided: IOpportunity[]
  supportRequested: IOpportunity[]
  adminAllTotal: number
  supportProvidedTotal: number
  supportRequestedTotal: number

  // lifecycle hooks
  async created () {
    if (!this.isAdmin) {
      this.$router.push(this.$route.fullPath.replace('/admin', ''))
    }
    await this.$store.dispatch('listAdminOpportunities')
    await this.$store.dispatch('listSupportRequestedOpportunities')
    await this.$store.dispatch('listSupportProvidedOpportunities')
  }

  // methods
  private async unpublish () {
    this.unpublishDialog = false
    this.routeBackToOppsPage()

    await waitAsync(MODAL_TRANSITION_TIME)

    this.$store.dispatch('upsertOpportunity', {
      id: this.opportunitySelected?.id,
      input: {
        networkType: 0,
        status: null
      }
    })
  }

  private clearSearch (listName: AdminOppsListName) {
    if (!this.searchField[listName]) return
    this.searchField[listName] = {
      headline: '',
      industry: '',
      location: ''
    }
    this.handleSearch(listName, this.searchField[listName])
  }

  // handlers
  private async handleFetchMore (listName: AdminOppsListName, pagination: IPagination) {
    this.fetchData(listName, pagination)
  }

  private async handleSearch (listName: AdminOppsListName, search: IOppSearchField) {
    this.fetchData(listName, { page: 0, limit: PAGINATION_LIMIT })
  }

  getActionByListName (listName: AdminOppsListName): string|undefined {
    let requestAction
    switch (listName) {
    case 'adminAllOpps':
      requestAction = 'listAdminOpportunities'
      break
    case 'supportProvided':
      requestAction = 'listSupportProvidedOpportunities'
      break
    case 'supportRequested':
      requestAction = 'listSupportRequestedOpportunities'
      break
    }
    if (!requestAction) {
      console.warn('RequestAction is not found!', listName)
    }
    return requestAction
  }

  isSearching (listName: AdminOppsListName): boolean {
    const searchField = this.searchField[listName]
    if (!searchField) return false
    return !!searchField.headline || !!searchField.industry || !!searchField.location
  }
}
</script>
<style lang="scss">
.v-dialog:not(.v-dialog--fullscreen) {
  margin: 10px;
}
</style>
